export const CONTACT = {
  phoneDisplay: "073-413 87 28",
  phoneHref: "tel:+46734138728",
  email: "kontakt@casagonbygg.se",
  city: "Höör",
  serviceArea: "Hela Skåne & hela Göteborg",
};

export const IMG = {
  floor: "/assets/project-floor-hero.webp",
  kitchen1: "/assets/project-kitchen-1.webp",
  kitchen2: "/assets/project-kitchen-2.webp",
  kitchenConcrete: "/assets/project-kitchen-concrete.webp",
  darkKitchen: "/assets/project-dark-kitchen.webp",
  lightwoodKitchen: "/assets/project-lightwood-kitchen.webp",
  staircase: "/assets/project-staircase.webp",
  exterior: "/assets/project-exterior-wood.webp",
  casagonLogo: "/assets/casagon-logo-exact.webp?v=1",
};

export const NAV = [
  { to: "/", label: "Start" },
  { to: "/golvlaggning", label: "Golvläggning" },
  { to: "/bygg-renovering", label: "Bygg & renovering" },
  { to: "/projekt", label: "Projekt" },
  { to: "/kontakt", label: "Kontakt" },
];

// Curated projects — only honest, verifiable labels. No invented client/scope/material.
export const PROJECTS = [
  {
    id: "tragolv",
    label: "Golvläggning",
    title: "Parkett & trägolv",
    location: null,
    desc: "Golvläggning med fokus på underarbete, precision och finish.",
    img: IMG.floor,
    alt: "Detalj av lagt trägolv med naturligt ljus",
    span: "wide",
  },
  {
    id: "svart-kok",
    label: "Kök & renovering",
    title: "Köksprojekt",
    location: null,
    desc: "Köksmontering i ett modernt, mörkt formspråk.",
    img: IMG.darkKitchen,
    alt: "Modernt svart kök med köksö och betonggolv",
    span: "tall",
  },
  {
    id: "ljust-kok",
    label: "Kök & renovering",
    title: "Kök & inredning",
    location: null,
    desc: "Renovering och montering av kök i ljust trä.",
    img: IMG.lightwoodKitchen,
    alt: "Ljust träkök i renoverat rum",
    span: "tall",
  },
  {
    id: "trappa",
    label: "Snickeri & bygg",
    title: "Trappa i trä",
    location: null,
    desc: "Snickeri och byggarbete i ett bostadsprojekt.",
    img: IMG.staircase,
    alt: "Trappa i trä mot betongvägg i modern bostad",
    span: "tall",
  },
  {
    id: "byggprojekt",
    label: "Byggprojekt",
    title: "Byggprojekt i trä",
    location: null,
    desc: "Exteriört byggarbete med träfasad.",
    img: IMG.exterior,
    alt: "Byggprojekt med träfasad och stora fönsterpartier",
    span: "wide",
  },
  {
    id: "kok-2",
    label: "Kök & renovering",
    title: "Köksmiljö",
    location: null,
    desc: "Renoverad köksmiljö.",
    img: IMG.kitchen1,
    alt: "Renoverat kök",
    span: "tall",
  },
  {
    id: "kok-betong",
    label: "Kök & renovering",
    title: "Köksprojekt",
    location: null,
    desc: "Kök med råa material och betonggolv.",
    img: IMG.kitchenConcrete,
    alt: "Kök med betonggolv och råa material",
    span: "tall",
  },
];

export const SERVICES = [
  {
    n: "01",
    title: "Köksmontering",
    desc: "Montering och renovering av kök – från stommar till färdig köksmiljö.",
    img: IMG.lightwoodKitchen,
  },
  {
    n: "02",
    title: "Dörrar & fönster",
    desc: "Byte och montering av dörrar och fönster i bostäder och fastigheter.",
    img: IMG.exterior,
  },
  {
    n: "03",
    title: "Hus- & lägenhetsrenovering",
    desc: "Renoveringsarbeten för hem och fastigheter – privat och företag.",
    img: IMG.kitchenConcrete,
  },
  {
    n: "04",
    title: "Till- & ombyggnation",
    desc: "Mindre och större ombyggnationer och tillbyggnader.",
    img: IMG.staircase,
  },
];
